import { BasicEntity } from "../../core/models/basic-entity";

export class AccountType extends BasicEntity {
   
    constructor(entity?: Partial<AccountType>) {
        super();
        Object.assign(this, entity);
    }
}
